module.exports = __webpack_public_path__ + "static/media/bottom-money.c0f5677b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/activity/giftcard/bottom-money.png
// module id = 1856
// module chunks = 6